import CampaignTable from './CampaignTable'

export { CampaignTable }
export default CampaignTable
